import { Box } from "@mui/material";
import React from "react";
import CentreOfGravityPanel from "./CentreOfGravityPanel";
import ChassisLoadsPanel from "./ChassisLoadsPanel";
import VehicleMeasuresPanel from "./VehicleMeasuresPanel";
import AdditionalEquipmentPanel from "./AdditionalEquipmentPanel";
import FinalResultsPanel from "./FinalResultsPanel";
import { useStyles } from "./styles";

const CentreOfGravity = () => {
  const styles = useStyles();

  return (
    <Box className={styles.pageRoot}>
      <CentreOfGravityPanel />
      <ChassisLoadsPanel />
      <VehicleMeasuresPanel />
      <AdditionalEquipmentPanel />
      <FinalResultsPanel />
    </Box>
  );
};

export default CentreOfGravity;
